<template>
      <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'الحفظ والمراجعة'" :to="{name: 'saveReviewPlans'}">خطة الحفظ والمراجعة</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'saveReviewPlans.edit', params: {id: data.form.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                           <i class="flaticon-computer-4"></i>
                                          بيانات خطة الحفظ والمراجعة</h4>

                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="update()">
                                         <div class="row">
                                          
                                       <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة الدراسية</label>
                                            <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroups" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4" >
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الصف الدراسى</label>
                                           
                                            <treeselect :options="groups" v-model="data.form.group_id" @select="getLessons" :multiple="false" />

                                            <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                                                  {{ getErrors['group_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4" >
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الحلقة</label>
                                            <treeselect :options="lessons" :auto-load-root-options="true" v-model="data.form.lesson_id" @select="getTeachers" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['lesson_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['lesson_id']">
                                                  {{ getErrors['lesson_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                       <div class="col-md-6 mt-2" >
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الطالب</label>
                                            <treeselect :options="students" :auto-load-root-options="true" v-model="data.form.student_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['student_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['student_id']">
                                                  {{ getErrors['student_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                       <div class="col-md-6 mt-2">
                                          <label for=""> الحالة </label>
                                          <select :disabled="!hasPermissions('saveReviewPlans_status')" id="type" class="form-control" v-model="data.form.type">
                                            <option v-for="(value, k) in types" :value="k" >{{ value }}</option>
                                          </select>
                                        </div>
                                      
                                      <div class="col-md-12 table-responsive mt-2">
                                        <a href="#" v-if="data.form.student_id"  @click.prevent="addStudent" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-plus">إضافة جديد </a>

                                        <table class="table table-bordered">
                                          <thead>
                                            <tr class="text-center">

                                              <th colspan="4">الطالب</th>
                                              <th >التاريخ</th>
                                              <th >الملاحظات</th>
                                              <th colspan="4">متابعة الحفظ</th>
                                              <th colspan="4">متابعة المراجعة</th>
                                            </tr>
                                            <tr>

                                              <th style="min-width: 60px;">كود الطالب</th>
                                              <th style="min-width: 160px;">الطالب</th>
                                              <th style="min-width: 160px;">ملتزم/غير ملتزم</th>
                                              <th style="min-width: 160px;">نوع الورد</th>
                                              <th style="min-width: 160px;">التاريخ</th>
                                              <th style="min-width: 160px;">الملاحظات</th>

                                              <th style="min-width: 160px;">من</th>
                                              <th style="min-width: 160px;">رقم الآية</th>
                                              <th style="min-width: 160px;">إى سورة</th>
                                              <th style="min-width: 160px;">رقم الآية</th>

                                              <th style="min-width: 160px;">من</th>
                                              <th style="min-width: 160px;">رقم الآية</th>
                                              <th style="min-width: 160px;">إى سورة</th>
                                              <th style="min-width: 160px;">رقم الآية</th>

                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr v-if="data.form.student_id" v-for="(st, k) in data.form.details" :key="k">

                                              <td v-if="data.form.details[k]">
                                                <h6>{{data.form.student_id}}</h6>
                                                <a href="#" @click.prevent="deleteFromStudent(data.form.details[k])" class="text-danger">X</a>
                                              
                                              </td>
                                              <td v-if="data.form.details[k]">
                                                <h6>{{selectedStudentName}}</h6>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.student_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.student_id']">
                                                      {{ getErrors['students.'+k+'.student_id'][0] }}
                                                </div>
                                              </td>
                                               <td v-if="data.form.details[k]">
                                                <select class="form-control" v-model="data.form.details[k].is_committed">
                                                  <option value="1"> ملتزم </option>
                                                  <option value="0">غير ملتزم</option>
                                                </select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.plan_type'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.plan_type']">
                                                      {{ getErrors['students.'+k+'.plan_type'][0] }}
                                                </div>
                                              </td>
                                              <td v-if="data.form.details[k]">
                                                <select class="form-control" v-model="data.form.details[k].plan_type" @change="handleType(k);">
                                                  <option value="حفظ ومراجعة">حفظ و مراجعة</option>
                                                  <option value="حفظ">حفظ ففط</option>
                                                  <option value="مراجعة">مراجعة ففط</option>
                                                </select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.plan_type'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.plan_type']">
                                                      {{ getErrors['students.'+k+'.plan_type'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                            <date-picker v-model="data.form.details[k].date_and_time" :editable="true" :calendar="'hijri'"></date-picker>
                                                
                                              </td>
                                              <td>
                                                <input type="text" v-model="data.form.details[k].notes" class="form-control">
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.details[k].plan_type == 'مراجعة'" :options="sura" v-model="data.form.details[k].save_from" @input="setAyaFromVal($event, k)" ></v-select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.save_from'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.save_from']">
                                                      {{ getErrors['students.'+k+'.save_from'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.details[k].plan_type == 'مراجعة'" :options="data.form.details[k].ayaFromOptions" v-model="data.form.details[k].save_from_aya"></v-select>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.save_from_aya'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.save_from_aya']">
                                                      {{ getErrors['students.'+k+'.save_from_aya'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.details[k].plan_type == 'مراجعة'" :options="sura" v-model="data.form.details[k].save_to" @input="setAyaToVal($event, k)" ></v-select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.save_to'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.save_to']">
                                                      {{ getErrors['students.'+k+'.save_to'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.details[k].plan_type == 'مراجعة'" :options="data.form.details[k].ayaToOptions" v-model="data.form.details[k].save_to_aya"></v-select>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.save_to_aya'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.save_to_aya']">
                                                      {{ getErrors['students.'+k+'.save_to_aya'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.details[k].plan_type == 'حفظ'" :options="sura" v-model="data.form.details[k].review_from" @input="setReviewAyaVal($event, k)" ></v-select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.review_from'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.review_from']">
                                                      {{ getErrors['students.'+k+'.review_from'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.details[k].plan_type == 'حفظ'"  :options="data.form.details[k].reviewAyaFromOptions" v-model="data.form.details[k].review_from_aya"></v-select>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.review_from_aya'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.review_from_aya']">
                                                      {{ getErrors['students.'+k+'.review_from_aya'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.details[k].plan_type == 'حفظ'"  :options="sura" v-model="data.form.details[k].review_to" @input="setReviewAyaToVal($event, k)" ></v-select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.review_to'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.review_to']">
                                                      {{ getErrors['students.'+k+'.review_to'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.details[k].plan_type == 'حفظ'"  :options="data.form.details[k].reviewAyaToOptions" v-model="data.form.details[k].review_to_aya"></v-select>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.review_to_aya'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.review_to_aya']">
                                                      {{ getErrors['students.'+k+'.review_to_aya'][0] }}
                                                </div>
                                              </td>
                                                
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>


                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'saveReviews'}">
                                      <span>رجوع</span>
                                    </router-link>
                              </form>
                            </div>
                        </div>
                    </div>

                </div>


            </div>
</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,

  },
  data() {
    return {
       types:{
        'pending': 'غير معتمد',
        'done': 'معتمد'
      },
      isChangedData: 0,
      trans: {},
      data: {
        checkerExit: 0,
        
        form: {
          student_id: '',
          lesson_id: '',
          stage_id: '',
          group_id: '',
          type: 'done',
          details: [],
        },
        permissions: [],
        isRequested: false,
        errors: {},
        paginated: {},
        allSelected: false,
      },
      isChanged: 0,
      teachers: [],
      lessons: [],
      stages: [],
      groups: [],
      sura: [],
      allSour: []
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
     resetForm(){
      this.data.form = {
           teacher_id: '',
          lesson_id: '',
          stage_id: '',
          group_id: '',
          type: 'done',
          details: [],
        };
    },
    reClcDegree(k){
      this.data.form.details[k].student_degree = 0;
      this.data.form.details[k].review_degree = 0;
      this.data.form.details[k].save_degree = 0;
    },
    getInfo() {
      this.$baseApi.get('/saveReviewPlans/' + this.$route.params.id + '/edit').then((response) => {
        if (response.data.code == 200 && response.data.data != null) {
          this.data.form        = response.data.data.saveReviewPlan;
          this.students            = response.data.data.students;
          this.sura            = response.data.data.sura;
          this.stages            = response.data.data.stages;
          this.groups            = response.data.data.groups;
          this.lessons            = response.data.data.lessons;
          this.allSour            = response.data.data.allSour;

            this.data.form.details = this.data.form.details.map(detail => ({
            ...detail,
            ayaFromOptions: detail.ayaFromOptions || [],
            ayaToOptions: detail.ayaToOptions || [],
            reviewAyaFromOptions: detail.reviewAyaFromOptions || [],
            reviewAyaToOptions: detail.reviewAyaToOptions || []
        }));

        // Now safely call your triggers
        this.data.form.details.forEach((detail, k) => {
            if (detail.save_from) this.setAyaFromVal(detail.save_from, k);
            if (detail.save_to) this.setAyaToVal(detail.save_to, k);
            if (detail.review_from) this.setReviewAyaVal(detail.review_from, k);
            if (detail.review_to) this.setReviewAyaToVal(detail.review_to, k);
        });

         
          setTimeout(() => {
          this.isChangedData = 1;
            
          }, 3000);
        } else if (response.data.code == 404) {
          router.push('/saveReviewPlans');
        } else {
          alert(response.data.data.error);
          router.push('/saveReviewPlans');
        }
      });
    },
    update() {
      this.data.isRequested = true;
      this.$baseApi.patch('/saveReviewPlans/' + this.data.form.id, this.data.form).then((response) => {
        if (response.data.code === 200) {
          this.resetForm();
          localStorage.setItem('flash_message', 'تمت عملية العديل');
          this.sweetAlert('تم التعديل بنجاح');
          router.push('/saveReviewPlans');

        }
      }).catch((error) => {
        this.sweetAlert(error.response.data.errors[0], 'error');
        this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
        this.data.isRequested = false
      })
    },

     deleteFromStudent(data){
      this.data.form.details.splice(this.data.form.details.indexOf(data), 1);
    },
    addStudent(){
      this.data.form.details.push({
          notes: '',
          date_and_time: '',
          stOptions: [],
          ayaFromOptions: [],
          ayaToOptions: [],
          reviewAyaFromOptions: [],
          reviewAyaToOptions: [],
          type: 'حفظ ومراجعة',
          save_from: '',
          save_from_aya: '',
          save_to: '',
          save_to_aya: '',

          review_from: '',
          review_from_aya: '',
          review_to: '',
          review_to_aya: '',
          is_committed: 1,
      })
    },
    handleType(k){
      let type = this.data.form.details[k].type;
      if(type == 'حفظ'){
        this.data.form.details[k].review_to_aya = '';
        this.data.form.details[k].review_to = '';
        this.data.form.details[k].review_from_aya = '';
        this.data.form.details[k].review_from = '';
      }else if(type == 'مراجعة'){
        this.data.form.details[k].save_to_aya = '';
        this.data.form.details[k].save_to = '';
        this.data.form.details[k].save_from_aya = '';
        this.data.form.details[k].save_from = '';
      }else{

      }
      this.clcDegree(k);
    },
    clcDegree(k){
      if(this.data.form.details[k].review_degree > 20){
        this.data.form.details[k].review_degree = 20;
        this.sweetAlert('لا يمكنك اختيار رقم اكبر من 20', 'warning');
      }
      if(this.data.form.details[k].save_degree > 20){
        this.data.form.details[k].save_degree = 20;
        this.sweetAlert('لا يمكنك اختيار رقم اكبر من 20', 'warning');
      }
      let type = this.data.form.details[k].type;
      if(type == 'حفظ ومراجعة'){
        if(this.data.form.details[k].review_degree && this.data.form.details[k].save_degree){
          let clc = ((Number(this.data.form.details[k].review_degree) + Number(this.data.form.details[k].save_degree)) / 2);
          this.data.form.details[k].student_degree = clc;
        }
      }else if(type == 'حفظ'){
        if(this.data.form.details[k].save_degree > 20){
          this.data.form.details[k].save_degree = 20;
        }
        this.data.form.details[k].student_degree = this.data.form.details[k].save_degree;
      }else{
        this.data.form.details[k].student_degree = this.data.form.details[k].review_degree;

      }
    },

     getGroups(val){
         this.$baseApi.get('/saveReviewPlans/' + this.$route.params.id + '/edit?option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.groups;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      getLessons(val){
         this.$baseApi.get('/saveReviewPlans/' + this.$route.params.id + '/edit?option=lesson&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.lessons = response.data.data.lessons;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      getStudents(val){
         this.$baseApi.get('/saveReviewPlans/' + this.$route.params.id + '/edit?option=student&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.students = response.data.data.students;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        }).catch((error) => {
          this.data.form.students = [];
          this.sweetAlert(error.response.data.errors[0], 'error');
        });;
      },


      setReviewAyaVal($event, key){
              //  this.data.form.students[key].review_to  = $event;

         this.$baseApi.get('/saveReviewPlans/' + this.$route.params.id + '/edit?sura=' + $event).then((response)=>{
            if(response.data.code == 200){

               this.data.form.details[key].reviewAyaFromOptions  = response.data.data.options;
               this.data.form.details[key].reviewAyaToOptions  = response.data.data.options;


            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

       setReviewAyaToVal($event, key){
         this.$baseApi.get('/saveReviewPlans/' + this.$route.params.id + '/edit?sura=' + $event).then((response)=>{
            if(response.data.code == 200){

               this.data.form.details[key].reviewAyaToOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      setAyaFromVal($event, key){
        // this.data.form.students[key].save_to = $event;

         this.$baseApi.get('/saveReviewPlans/' + this.$route.params.id + '/edit?sura=' + $event).then((response)=>{
            if(response.data.code == 200){

               this.data.form.details[key].ayaFromOptions  = response.data.data.options;
               this.data.form.details[key].ayaToOptions    = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      setAyaToVal($event, key){
        this.$baseApi.get('/saveReviewPlans/' + this.$route.params.id + '/edit?sura=' + $event).then((response)=>{
            if(response.data.code == 200){

               this.data.form.details[key].ayaToOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      setNewStVal($event, k){
          for (let index = 0; index < this.data.form.students.length; index++) {
              if($event.id == this.data.form.students[index].student_id){
                this.sweetAlert('لا يمكنك اختيار طالب اكثر من مرة', 'warning');
                this.data.form.details[k].student_id = null;
                this.data.form.details[k].student    = null;
                return;
              }
          }
           this.data.form.details[k].student_id = $event && $event.id ? $event.id : '';
           this.data.form.details[k].student = $event && $event.id ? $event.label : '';
        },

  loadOptions(search, key) {
    if(this.data.form.lesson_id == ''){
      this.sweetAlert('لا يمكنك اختيار طالب قبل اختيار الحلقة', 'warning');
      return;
    }
    if(search == ''){
      this.data.form.students[key].stOptions = [];
      return;
    }
      this.$baseApi.get('/saveReviewPlans/' + this.$route.params.id + '/edit?student=' + search + '&lesson=' + this.data.form.lesson_id).then((response)=>{
            if(response.data.code == 200){

               this.data.form.details[key].stOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
  }
  },
  computed: {
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    selectedStudentName() {
    if (!this.data.form.student_id) return '';
    // Flatten students tree to find selected node
    const findStudent = (nodes, id) => {
      for (const node of nodes) {
        if (node.id === id) return node.label; // assuming label has the name
        if (node.children) {
          const res = findStudent(node.children, id);
          if (res) return res;
        }
      }
      return null;
    }
    return findStudent(this.students, this.data.form.student_id);
  }
  },
  watch:{
     'data.form.date_and_time': function (newVal, oldVal){
        if(this.isChangedData){
          this.getStudents();
        }
     }
 }
};
</script>
<style>
.role-box {
  border-radius: 6px;
  box-shadow: 1px 1px 4px 0 #0000004a;
  padding: 11px;
}

.role-box h5 {
  text-align: center;
  border-bottom: 1px solid #8080808c;
}
.role-selected {
  border-radius: 6px;
  box-shadow: 0 2px 2px 0 #00000042;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 11px;
}
</style>
